import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Scoreboard from './Scoreboard';
import { ScoreboardProvider } from './context/ScoreboardContext';
import { MusicProvider } from './context/MusicContext';

import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import './App.css';
import ScoreboardLive from './ScoreboardLive';
import HeaderSection from './content/HeaderSection';
import HeroSection from './content/HeroSection';
import FeatureSection from './content/FeatureSection';
import CommunitySection from './content/CommunitySection';
import FooterSection from './content/FooterSection';
import Manual from './pages/Manual';
import VideoPlayer from './VideoPlayer';
import VideoGuides from './pages/VideoGuides';
import Changelog from './pages/Changelog';

import { useState } from 'react';

function HomePage() {
  useGoogleAnalytics();
  const [lang, setLang] = useState('de');
  return (
    <div>
      <HeaderSection lang={lang} setLang={setLang} />
      <HeroSection lang={lang} />
      <FeatureSection lang={lang} />
      <CommunitySection lang={lang} />
      <FooterSection lang={lang} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScoreboardProvider>
        <MusicProvider>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/control" element={<Scoreboard />} />
          <Route path="/liveview" element={<ScoreboardLive />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/videos" element={<VideoGuides />} />
          <Route path="/videoplayer" element={<VideoPlayer />} />
          <Route path="/changelog" element={<Changelog />} />
          </Routes>
        </MusicProvider>
      </ScoreboardProvider>
    </Router>
  );
}

export default App;
